import React from "react";
import { MdDesktopWindows, MdPhoneIphone } from "react-icons/md";
import { HiDesktopComputer } from "react-icons/hi";
const platforms = [
  {
    title: "Windows",
    type: "desktop",
    description: "Download our Windows app",
    link: "https://download.mql5.com/cdn/web/moneyplant.fx.ltd/mt5/moneyplantfx5setup.exe",
  },
  {
    title: "Mac (iOS)",
    type: "desktop",
    description: "Download our Mac app",
    link: "https://download.mql5.com/cdn/mobile/mt5/ios?hl=en",
  },
  {
    title: "Android App",
    type: "mobile",
    description: "Download our Android app",
    link: "https://download.mql5.com/cdn/mobile/mt5/ios?hl=en",
    
  },
  {
    title: "iPhone App",
    type: "mobile",
    description: "Download our iPhone app",
    link: "https://moneyplantfx.com/wp-content/uploads/metatrader5.apk",
  },
];

export const PlatformCards = () => {
  return (
    <div className="p-6 bg-gray-100 min-h-screen ">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 justify-items-center">
        {platforms.map((platform, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-md p-4 flex flex-col items-center w-full max-w-xs"
          >
            <div className="w-full h-32 bg-gradient-to-br from-[#1e59bb] to-orange-500 rounded-md mb-4 flex items-center justify-center">
              {platform.type === "desktop" ? (
                <HiDesktopComputer className="text-white text-7xl" />
              ) : (
                <MdPhoneIphone className="text-white text-7xl" />
              )}
            </div>

            <h3 className="text-md font-semibold">{platform.title}</h3>
            <p className="text-xs text-gray-500 text-center mb-2">
              {platform.description}
            </p>
            <a
              href={platform.link}
              className="text-sm border border-orange-500 text-orange-500 px-4 py-1 rounded hover:bg-orange-500 hover:text-white transition"
              target="_blank"
              rel="noopener noreferrer"
            >
              DOWNLOAD
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
